module.exports = __webpack_public_path__ + "img/User-Default.5c6aa235.jpg";